// extracted by mini-css-extract-plugin
module.exports = {"root":"FeatureSets_root__2i5o0","title":"FeatureSets_title__3KqTS","wrapper":"FeatureSets_wrapper__BlUJJ","getStarted":"FeatureSets_getStarted__3GFTj"};